import { useIntl } from "react-intl";

const CustomizableQueues = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomizableQueues.header",
            defaultMessage: "Customizable queues"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomizableQueues.body",
            defaultMessage:
                "Jira Service Management has default queues that your project admin can update to automatically triage issues for your team. Agents can see how many issues are in each queue and switch queues when needed."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default CustomizableQueues;
